import React from 'react';


export default function DropDown(){

    return(
         <div className="drop">
           <p>Home</p>
           <p>About</p>
           <p>Contact</p>
           <p>Blog</p>
           <p>Careers</p>
       </div>
    )
}